import object from 'helpers/object'


export const initialState = {
  groups: [],
  members: {},
  quantity: {},
  subscription: {},
  isFetching: true,
}


export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setGroups = (state, payload) => (
  object.setIn(state, [ 'groups' ], payload)
)

export const setGroupMembers = (state, payload) => (
  object.setIn(state, [ 'members', payload.groupId ], payload.members)
)

export const setGroupMembersTotal = (state, payload) => {
  return object.updateIn(state, [ 'members' ], (members) => {
    // members[groupId] = members[groupId].map(({ }) => {})

    payload.forEach(({ groupId, memberId, total }) => {
      members[groupId] = members[groupId].map((member) => {
        const { id } = member

        if (id === memberId) {
          member.total = total
        }

        return member
      })
    })

    return members
  })
}

export const setGroupQuantity = (state, payload) => (
  object.setIn(state, [ 'quantity', payload.groupId ], payload.quantity)
)

export const setGroupMemberSubscription = (state, payload) => (
  object.setIn(state, [ 'subscription', payload.groupId, payload.memberId ], payload.subscription)
)
